import { crudRequest } from '@/services/api';

const params = {}
export default {
    namespace: 'actualProductionRatioBoard',
    state: {
        detailCenter: '',
        onSearch: false,
        centerFilter: ''
    },

    effects: {
    },

    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
    }
}
